import React from "react";
import "./TripDetails.css";
import { DATE_FORMAT, TIME_FORMAT } from "../../../../utils/constants";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const TripDetailsApprovedView = ({ flightApprovalData }) => {
  const getLatestApprovalData = (data) => {
    if (!data || !Array.isArray(data)) return [];

    const groupedByState = data.reduce((acc, item) => {
      const state = item.approvalState;
      if (
        !acc[state] ||
        dayjs(item.reviewedAt).isAfter(dayjs(acc[state].reviewedAt))
      ) {
        acc[state] = item;
      }
      return acc;
    }, {});

    // Convert back to array and sort by reviewedAt to maintain chronological order
    return Object.values(groupedByState).sort((a, b) =>
      dayjs(a.reviewedAt).isBefore(dayjs(b.reviewedAt)) ? -1 : 1
    );
  };

  const filteredApprovalData = getLatestApprovalData(flightApprovalData);
  return (
    <div className="trip-details-approved-container">
      {filteredApprovalData?.map((item, index) => (
        <>
          <div key={index} className="trip-details-approved">
            {item?.approvalState?.toLowerCase().includes("approved") ? (
              <div>{`Approved by ${item?.name}`}</div>
            ) : item?.approvalState?.toLowerCase().includes("cancelled") ? (
              <div>{`Cancelled by ${item?.name}`}</div>
            ) : (
              <div>{item?.name}</div>
            )}
            <div>{`(${item?.email})`}</div>
            <div>
              on {dayjs(item?.reviewedAt).format(DATE_FORMAT)} at{" "}
              {dayjs(item?.reviewedAt).format(TIME_FORMAT)}
            </div>
          </div>
          {index + 1 !== flightApprovalData.length && (
            <div className="trip-details-approved-divider"></div>
          )}
        </>
      ))}
    </div>
  );
};

export default TripDetailsApprovedView;
